<template>
  <form>
    <div class="field">
      <div class="field-body">
        <!-- COMPANY BEGIN -->
        <div class="field">
          <label class="label" for="company">{{$t('company', 'Company')}} *</label>
          <div class="control">
            <input id="company" type="text" class="input" :class="errors.company && 'is-danger'" v-model="registration.company">
          </div>
          <template v-if="errors.company">
            <p v-for="error in errors.company" :key="error" class="is-danger help">{{ error }}</p>
          </template>
        </div>
        <!-- COMPANY END -->
        <!-- CONTACT PERSON BEGIN -->
        <div class="field">
          <label class="label" for="contact-person">{{$t('contact-person', 'Contact person')}} *</label>
          <div class="control">
            <input id="contact-person" type="text" class="input" :class="errors.contactPerson && 'is-danger'" v-model="registration.contactPerson">
          </div>
          <template v-if="errors.contactPerson">
            <p v-for="error in errors.contactPerson" :key="error" class="is-danger help">{{ error }}</p>
          </template>
        </div>
        <!-- CONTACT PERSON END -->
      </div>
    </div>
    <div class="field">
      <div class="field-body">
        <!-- EMAIL BEGIN -->
        <div class="field">
          <label class="label" for="email">E-mail *</label>
          <div class="control">
            <input id="email" type="text" class="input" :class="errors.email && 'is-danger'" v-model="registration.email">
          </div>
          <template v-if="errors.email">
            <p v-for="error in errors.email" :key="error" class="is-danger help">{{ error }}</p>
          </template>
        </div>
        <!-- EMAIL END -->
        <!-- TELEPHONE BEGIN -->
        <div class="field">
          <label class="label" for="telephone">{{$t('telephone', 'Telephone')}} *</label>
          <div class="control">
            <input id="telephone" type="text" class="input" :class="errors.telephone && 'is-danger'" v-model="registration.telephone">
          </div>
          <template v-if="errors.telephone">
            <p v-for="error in errors.telephone" :key="error" class="is-danger help">{{ error }}</p>
          </template>
        </div>
        <!-- TELEPHONE END -->
      </div>
    </div>
    <!-- COMMENT BEGIN -->
    <div class="field">
      <label class="label" for="comment">{{$t('comment', 'Comment')}}</label>
      <div class="control">
        <textarea class="textarea" id="comment" v-model="registration.comment" />
      </div>
    </div>
    <!-- COMMENT END -->
    <div class="field">
      <label for="registeredBy" class="label">{{$t('registered-by', 'Registered by')}}</label>
      <div class="control">
        <input id="registeredBy" type="text" class="input is-static" v-model="registration.registeredBy" readonly>
      </div>
    </div>
    <div class="field">
      <div class="field-body">
        <!-- IS ENABLED BEGIN -->
        <div class="field">
          <div class="control">
            <label class="label" for="isEnabled">
              <input class="checkbox" id="isEnabled" type="checkbox" v-model="registration.isEnabled" />
              {{$t('enabled', 'Enabled')}}
            </label>
          </div>
        </div>
        <!-- IS ENABLED END -->
        <!-- IS VALIDATION BEGIN -->
        <div class="field">
          <div class="control">
            <label class="label" for="isValidation">
              <input class="checkbox" id="isValidation" type="checkbox" v-model="registration.isValidation" />
              {{$t('validation', 'Validation')}}
            </label>
          </div>
        </div>
        <!-- IS VALIDATION END -->
        <!-- IS PAID BEGIN -->
        <div class="field">
          <div class="control">
            <label class="label" for="isPaid">
              <input class="checkbox" id="isPaid" type="checkbox" v-model="registration.isPaid" />
              {{$t('paid', 'Paid')}}
            </label>
          </div>
        </div>
        <!-- IS PAID END -->
        <!-- IS SOLD BY KG BEGIN -->
        <div class="field">
          <div class="control">
            <label class="label" for="isSoldByKG">
              <input class="checkbox" id="isSoldByKG" type="checkbox" v-model="registration.isSoldByKG" />
              {{$t('sold-by-kg', 'Sold by KG')}}
            </label>
          </div>
        </div>
        <!-- IS SOLD BY KG END -->
        <!-- IS DELETED BEGIN -->
        <div class="field">
          <div class="control">
            <label class="label" for="isDeleted">
              <input class="checkbox" id="isDeleted" type="checkbox" v-model="registration.isDeleted" />
              {{$t('deleted', 'Deleted')}}
            </label>
          </div>
        </div>
        <!-- IS DELETED END -->
      </div>
    </div>
    <div class="field" v-if="showSubmit">
      <div class="control">
        <button class="button is-primary" type="submit" @click.prevent="submit">{{$t('submit', 'Submit')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
import auth from '../auth'

export default {
  name: 'RegistrationForm',
  props: {
    default: { type: Object, default: undefined },
    showSubmit: { type: Boolean, default: false }
  },
  data () {
    const registration = Object.assign(
      {},
      {
        registrationKey: 'N/A',
        firstRegistration: 'N/A',
        lastRegistration: 'N/A',
        registrationIndex: 'N/A',
        company: '',
        contactPerson: '',
        email: '',
        telephone: '',
        comment: '',
        registeredBy: auth.getUsername(),
        isEnabled: true,
        isValidation: true,
        isPaid: true,
        isSoldByKG: true,
        isDeleted: false
      },
      this.default
    )

    return {
      registration,
      errors: {}
    }
  },
  methods: {
    validateForm () {
      const { company, contactPerson, email, telephone } = this.registration

      this.errors = {}

      if (company && contactPerson && email && telephone) {
        return true
      }

      if (!company) {
        this.errors.company = [
          this.$t('is-required', {
            replace: { field: this.$t('company', 'Company') },
            defaultValue: 'Company is required'
          })
        ]
      }

      if (!contactPerson) {
        this.errors.contactPerson = [
          this.$t('is-required', {
            replace: { field: this.$t('contact-person', 'Contact person') },
            defaultValue: 'Contact person is required'
          })
        ]
      }

      if (!email) {
        this.errors.email = [
          this.$t('is-required', {
            replace: { field: 'Email' },
            defaultValue: 'Email is required'
          })
        ]
      }

      if (!telephone) {
        this.errors.telephone = [
          this.$t('is-required', {
            replace: { field: this.$t('telephone', 'Telephone') },
            defaultValue: 'Telephone is required'
          })
        ]
      }
    },
    submit () {
      if (this.validateForm()) {
        this.$emit('onSubmitRegistration', { ...this.registration })
      }
    }
  }
}
</script>
